import { provide, inject } from 'vue';

const ApplicationSettingsKey = Symbol('applicationSettings');

/**
 * Provide the applicationSettings reactive object to all descendants.
 * Call once in the root component (Application.vue).
 *
 * @param {import('vue').Reactive<Object>} settings
 */
export function provideApplicationSettings(settings) {
    provide(ApplicationSettingsKey, settings);
}

/**
 * Inject the applicationSettings reactive object provided by an ancestor.
 * Throws if called outside the provider tree.
 *
 * @returns {import('vue').Reactive<Object>}
 */
export function useInjectedApplicationSettings() {
    const settings = inject(ApplicationSettingsKey);
    if (!settings) {
        throw new Error(
            '[useInjectedApplicationSettings] applicationSettings was not provided. ' +
            'Ensure provideApplicationSettings() is called in an ancestor component.'
        );
    }
    return settings;
}
